import React from 'react';
import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import {
    Chart, Series, Size, Label,CommonSeriesSettings, Legend, ValueAxis, Title, Export, Tooltip,CommonAxisSettings, ArgumentAxis, Font
  } from 'devextreme-react/chart';

export default function CompanyCashFlow(props) {

    const { user } = useAuth(); 
    
    const dataInizio = props.dataInizio
    const dataFine = props.dataFine
    const intermediario = props.intermediario
    const commessa = props.commessa

    const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
    
    const filterPayload = { 
        intermediario: intermediario,
        fromDate: dataInizio,
        toDate: dataFine,
        commessa: commessa
    };
      

    const remoteDataSource = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/CompanyCashFlowByProject',
        onBeforeSend: (method, ajaxOptions) => {
            if (method == "load" ) {
                //initParametri();             
                var payload = ajaxOptions.data;
                payload.values = JSON.stringify(filterPayload);
                ajaxOptions.data = payload;          
                console.log(ajaxOptions.data);
                console.log('IntermediarioId:' + intermediario);
            }        
            //ajaxOptions.xhrFields = { withCredentials: true };
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}  
        },    
    });

    function pointClickHandler(e) {
        this.toggleVisibility(e.target);
    }
    
    function legendClickHandler(e) {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
        toggleVisibility(item);
    }

    function toggleVisibility(item) {
        item.isVisible() ? item.hide() : item.show();
    }

    return (
        <div >
            <Chart
                id="bar1"
                
                dataSource={remoteDataSource}
                palette="Bright"
                title="Cash Flow"
                onPointClick={pointClickHandler}
                onLegendClick={legendClickHandler}
            >

            <CommonSeriesSettings
                argumentField="meseAnno"
                type="splinearea"
            />
            <Series
                valueField="entrate"
                name="entrate"
            ></Series>
            <Series
                valueField="uscite"
                name="uscite"
            ></Series>

            <Legend visible={true}/>
            
            <Export enabled={false} />
            <Tooltip
                enabled={true}
                location="edge" visible
                //customizeTooltip={customizeTooltip2}
            />
            </Chart>
        </div>
    )
};